import * as React from "react";
import { withTranslation } from "react-i18next";
import { compose, pure, setDisplayName } from "recompose";
import { AppStoreLinks, Dialog, Header, Notification } from "components";
export var Render = function () {
    return React.createElement(Dialog, null,
        React.createElement(Header, { primary: window.env.COGNITO_IDENTITY_POOL_NAME, secondary: "" }),
        React.createElement(Notification, null),
        React.createElement(AppStoreLinks, null));
};
export function enhance() {
    return compose(withTranslation(), pure, setDisplayName("ResetVerificationSuccess"));
}
export var ResetVerificationSuccess = enhance()(Render);
